
import { Component, Vue, Prop } from 'vue-property-decorator';
  
import StepBase from "../StepBase.vue";
import { stepInfoType } from "@/types/Application";
import NoWillNotify from "./NoWillNotify.vue";


@Component({
    components:{
        StepBase,        
        NoWillNotify
    }
})

export default class NoWillNotifyStep extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;
    
};
